import { ProjectSelect, useRouting, ListItem, LIST_PROJECT_STATUS } from '@sitemax/smx-components';
import { useAppDispatch } from '../../utilities/hooks';
import { setterApp } from '../../slices/appSlice';
import { Flex, Form } from 'antd';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const FilterProjectBar = () => {
    const location = useLocation();
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();

    const { setUrlParam, getParams } = useRouting();

    useEffect(() => {
        dispatch(
            setterApp({
                globalFilterProject: getParams().gplist ? (getParams().gplist as string)?.split(',') : undefined,
                globalFilterStatus: getParams().gstatus as number,
            }),
        );
    }, []);

    const projectSelectHandler = (value: string | string[]) => {
        setTimeout(() => {
            dispatch(setterApp({ globalFilterProject: value as string[] }));

            setUrlParam({ gplist: (value as string[]).join(',') });
        });
    };

    const statusSelectHandler = (value: number) => {
        setTimeout(() => {
            dispatch(setterApp({ globalFilterStatus: value, globalFilterProject: undefined }));

            form.setFieldsValue({ globalFilterProject: undefined });
            setUrlParam({ gstatus: value, gplist: undefined });
        });
    };

    const hide = location.pathname.includes('documents');

    const filterFlexible = getParams().gstatus ? `[{"or":[{"status":${getParams().gstatus}}]}]` : undefined;

    return (
        <div style={{ width: '80%', display: hide ? 'none' : 'block' }}>
            <Form
                form={form}
                initialValues={{
                    globalFilterProject: getParams().gplist ? (getParams().gplist as string).split(',') : undefined,
                    globalFilterStatus: getParams().gstatus,
                }}
            >
                <Flex flex={1} justify={'start'} gap={5}>
                    <Form.Item label="" name={'globalFilterStatus'} style={{ width: '130px', margin: 0 }}>
                        <ListItem
                            style={{ flex: 1, width: '130px' }}
                            nameList={LIST_PROJECT_STATUS}
                            onChange={statusSelectHandler}
                            readonly
                        />
                    </Form.Item>
                    <Form.Item label="" name={'globalFilterProject'} style={{ width: 'calc(80% - 130px)', margin: 0 }}>
                        <ProjectSelect
                            style={{ width: '100%' }}
                            mode={'multiple'}
                            onChange={projectSelectHandler}
                            // localFilters={getParams().gstatus ? { status: getParams().gstatus as number } : undefined}
                            filterFlexible={filterFlexible}
                            maxTagCount={'responsive'}
                        />
                    </Form.Item>
                </Flex>
            </Form>
        </div>
    );
};

export default FilterProjectBar;
